import { render, staticRenderFns } from "./DotMap.vue?vue&type=template&id=49c0fe5f&scoped=true"
import script from "./DotMap.vue?vue&type=script&lang=js"
export * from "./DotMap.vue?vue&type=script&lang=js"
import style0 from "./DotMap.vue?vue&type=style&index=0&id=49c0fe5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c0fe5f",
  null
  
)

export default component.exports